import { faTrophy, faClipboardList, faUpload, faFilm, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { faImage, faFileLines } from '@fortawesome/free-regular-svg-icons'
import { library, dom } from '@fortawesome/fontawesome-svg-core'

library.add(faTrophy, faClipboardList, faUpload, faImage, faFilm, faFileLines, faCircleXmark)
dom.watch()
